'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var configure = require('./lib/configure.js');
var errCode = require('err-code');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

const createStart = configure.configure(api => {
  const start = async (options = {}) => {
    throw errCode__default['default'](new Error('Not implemented'), 'ERR_NOT_IMPLEMENTED');
  };
  return start;
});

exports.createStart = createStart;
